<div class="container">
    <div class="row trackerAccordion">
        <div class="col-sm-12 col-md-12 col-lg-12 mt-3 p-0 bg-white notification-box">
            <div id="notification-header" translate class="d-flex w-100 align-items-center font18">
                lblAllNotifications
            </div>

            <div class="sub-header">
                <span id="custName" class="font18">
                    {{notificationheader.customerName}}
                </span>
                <span id="orderNumber" class="font18">#{{notificationheader.orderNumber}}</span>
                <div class="d-flex align-items-center">
                    <div class="d-flex align-items-center">
                        <div class="licence-pl small text-center" [ngClass]="licensePlateClass">
                            <input type="text" aria-label="licencePlate" value="{{notificationheader.numberPlate}}"
                                readonly />
                        </div>
                    </div>
                </div>
            </div>

            <div class="vertical-scrollable">
                <div *ngFor="let notification of notificationList; let i = index">
                    <div class="p-2 btm-border" [ngClass]="notification.isRead ? 'bg-highlight-n': ''"
                        (click)="viewNotification(notification)">
                        <div class="row mx-1 justify-content-between">
                            <div>
                                <p class="msg-header" [ngClass]="notification.isRead ? 'fontnormal':'font-weight-bold'">
                                    {{ notification.subject }}</p>
                            </div>
                            <div>
                                <p class="msg-date">{{ notification.timeAgo }}</p>
                            </div>
                        </div>
                        <div class="mx-1">
                            <p class="msg-subject" [innerHTML]="notification.content"></p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex flex-sm-row flex-column justify-content-end">
                <button class="btn btn-primary mr-sm-2 btn-lg" (click)="moveBack();"><span translate>lblBack</span>
                </button>
            </div>

        </div>
    </div>
</div>